export const formatTiyinToSumLabel = (value: number) => {
  try {
    if (typeof value !== 'number') {
      return value
    }

    const sum = value / 100

    // Конвертируем в строку с двумя десятичными знаками
    const sumStr = sum.toFixed(2)

    // Разделяем на целую и дробную части
    const [integerPart, decimalPart] = sumStr.split('.')

    // Добавляем пробелы как разделители тысяч
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

    return `${formattedInteger}.${decimalPart}`
  } catch (error) {
    console.log('error while formatting tiyin to sum label', error)
    return value
  }
}
